import React from 'react';
import Spinner from 'react-spinkit';
import './full-screen-carousel-item.scss';
import { fireAnalytics, getQualityFlag, getMuteFlag, getLogoFlag } from '../../pages/utils'
import { setInterval } from 'timers';

export default class Artwork extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      artwork: props.artwork,
      showLoader: true,
      mute: false,
      highquality: getQualityFlag(),
      showLogo: true,
      subscription: props.subscription,
    };
    console.log("Logo : ", props.subscription);
    // localStorage.setItem("lastPlayedArtworkName", props.artwork.name);
    this.getArtworkUrl = this.getArtworkUrl.bind(this);
    this.getArtworkVideoUrl = this.getArtworkVideoUrl.bind(this);
    this.interval = null;
  }

  componentDidMount() {
    this.props.setCurrentArtworkId(this.props.artwork.id);
    this.interval = setInterval(() => {
      if (this.state.mute != getMuteFlag()) {
        this.setState({
          mute: getMuteFlag()
        })
      }
    }, 3000);
    if(!getLogoFlag()) {
      this.setState({ showLogo: false })
    }
    if (this.state.subscription) {
      if (getLogoFlag()) this.setState({ showLogo: true })
      setInterval(() => {
        if (getLogoFlag()) this.setState({ showLogo: true })
        else this.setState({ showLogo: false })
      }, 5000);
    } else {
      this.setState({ showLogo: true })
    }
    // setTimeout(() => {
    //   alert("adding mute");
    //   this.setState({
    //     mute: true
    //   })
    // }, 10000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  getArtworkUrl(artwork) {
    // const { showImage } = this.props;
    // if (!showImage) return '';
    if (artwork && artwork.media && artwork.media.image && artwork.media.image.low && artwork.media.image.low.landscape) {
      return artwork.media.image.low.landscape || artwork.media.image.low;
    }
    return '';
  }

  getArtworkVideoUrl(artwork) {
    const { isCurrent, nxtPre, other } = this.props;
    if (isCurrent || nxtPre || other) {
      // let url = artwork.media.video.full.low.mp4;
      let url = artwork.media.video.dash;
      if (isCurrent) {
        fireAnalytics('PlayVideo', 'Play', url);
      }
      return url;
    }
    return '';
  }

  componentWillReceiveProps({ artwork }) {
    this.setState({ artwork });
    // localStorage.setItem("lastPlayedArtworkName", artwork.name);
    if(artwork.id !== this.props.currentId && this.props.currentId !== undefined)
      this.props.setCurrentArtworkId(artwork.id);
  }

  render() {
    const { artwork } = this.state;

    return (
      <div className="full-screen-carousel-item">
        {
          this.state.showLogo ?
            <div className="video-artistName">
              <div className="ArtworkName">{artwork.name}</div>
              <div className="ArtistName">{`${artwork._embedded.artist.givenName} ${artwork._embedded.artist.surname}`}</div>
            </div> : null
        }
        {this.state.showLogo && <img className="blackdovelogo" src="https://assets.blackdove.com/images/blackdove-logo-2020.png" alt="" />}
        {this.state.showLoader && this.props.isCurrent ? <Spinner className="VideoLoader" name="double-bounce" color="white" fadeIn="none" style={{ width: '70px', height: '70px' }} /> : null}
        <div className="full-screen-carousel-item__image" style={!this.props.isCurrent && !this.props.nxtPre ? { backgroundImage: `url(${this.getArtworkUrl(artwork)})` } : { background: `none` }}>
          {(this.props.isCurrent) ? <video tabIndex="-1" src={this.getArtworkVideoUrl(artwork)} muted={this.state.mute ? true : false} autoPlay loop onPlay={() => { this.setState({ showLoader: false }) }} poster={this.getArtworkUrl(artwork)} ></video> : null}
          {(this.props.nxtPre || this.props.other) ? <video tabIndex="-1" src={this.getArtworkVideoUrl(artwork)} onCanPlay={() => { this.props.loadOthers() }} poster={this.getArtworkUrl(artwork)}></video> : null}
        </div>
      </div>
      // <div className="full-screen-carousel-item">
      //   {
      //     this.state.showLogo ?
      //       <div className="video-artistName">
      //         <div className="ArtworkName">{artwork.name}</div>
      //         <div className="ArtistName">{`${artwork._embedded.artist.givenName} ${artwork._embedded.artist.surname}`}</div>
      //       </div> : null
      //   }
      //   {this.state.showLogo && <img className="blackdovelogo" src="https://assets.blackdove.com/images/blackdove-logo-2020.png" alt="" />}
      //   <div className="full-screen-carousel-item__image" style={!this.props.isCurrent && !this.props.nxtPre ? { backgroundImage: `url(${this.getArtworkUrl(artwork)})` } : { background: `none` }}>
      //     {/* <img className="poster" id="poster" src={this.getArtworkUrl(artwork)} style={this.state.posterImage ? { display: 'block' } : { display: 'none' }} /> */}
      //     {this.state.showLoader && this.state.isCurrent ? <div tabIndex="-1" > <span className="spinner spinner--small loader" ></span></div> : null}
      //     {(this.props.isCurrent) ? <video tabIndex="-1" id="video" src={this.getArtworkVideoUrl(artwork)} muted={this.state.mute} autoPlay loop onPlay={() => { this.setState({ showLoader: false }) }} poster={this.getArtworkUrl(artwork)}></video> : null}
      //     {/* {(this.props.nxtPre || this.props.other) ? <video tabIndex="-1" src={this.getArtworkVideoUrl(artwork)} muted onCanPlay={() => { this.props.loadOthers() }} poster={this.getArtworkUrl(artwork)}></video> : null} */}
      //   </div>
      //   <div className="downloadInfo" style={this.state.downloadInfo ? { display: 'block' } : { display: 'none' }} >{this.downloadInfoText}</div>
      // </div>
    )
  }
};
